import { NewContractAction } from "src/actions/contact_boats"

export { NewContractAction }

export const NewReservationAction = ({ marinaSlug }) => ({
  label: "New Reservation",
  icon: "calendar-plus",
  iconStyle: "solid",
  href: (row) =>
    `/manage/${marinaSlug}/reservations/new/contact/${row.encodedId}`,
})

export const ArchiveContactAction = ({ onClickSingle }) => ({
  label: "Archive",
  icon: "box-archive",
  iconStyle: "solid",
  danger: true,
  onClickSingle,
  confirm: {
    title: "Archive captain",
    message: (row) => `Are you sure you want to archive ${row.name}?`,
    confirmLabel: "Archive",
  },
})

export const RestoreContactAction = ({ onClickSingle }) => ({
  label: "Restore",
  icon: "rotate-left",
  iconStyle: "solid",
  onClickSingle,
})
